import { Box, FormHelperText, styled } from '@mui/material';

interface CheckboxIconProps {
	isError?: boolean;
	customColor?: string;
}

export const CheckboxIcon = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'isError',
})<CheckboxIconProps>(({ isError, theme, color, customColor }) => {
	const resolvedColor =
		customColor ?? (color === 'primary' ? theme.palette.primary.main : theme.palette.secondary.main);

	return `
		box-sizing: border-box;
		border-radius: 5px;
		width: 18px;
		height: 18px;
		border: 1px solid;
		border-color: ${isError ? theme.palette.error.main : resolvedColor};

		.Mui-focusVisible & {
			outline: 2px solid ${resolvedColor}54;
			outline-offset: 2px;
		}
		input:hover:not(:disabled) ~ & {
			border-width: 2px;
		}
		input:disabled ~ & {
			border: 1px solid ${resolvedColor}54;
		}
		`;
});

export const CheckboxIconChecked = styled(CheckboxIcon)(({ theme, color, customColor }) => {
	const resolvedColor =
		customColor ?? (color === 'primary' ? theme.palette.primary.main : theme.palette.secondary.main);

	return `
		background-color: ${resolvedColor};
		border: none;
		&::before {
			display: block;
			width: 18px;
			height: 18px;
			background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E");
			content: '';
		}
		input:disabled ~ & {
			background-color: ${resolvedColor}54;
			border: none;
		}
		`;
});

export const Container = styled(Box)`
	display: flex;
	flex-flow: column nowrap;
`;

export const ErrorMessage = styled(FormHelperText)<{ hasChildren: boolean }>(
	({ theme, hasChildren }) => `
	color: ${theme.palette.error.main};
	font-size: 0.7rem;
    line-height: 1rem;
	min-height: 1rem;
    letter-spacing: 0.016rem;
	margin: ${hasChildren ? `5px 0px 0px 28px` : `0px`};
	display: inline-flex;
	gap: 3px;
	align-items: center;
	margin-top: -5px;
`
);
